export interface AnnotatorComponentState {
  jobId?: number, // client Id
  currentFrameIndex: number
}

export const initialAnnotatorComponentState : AnnotatorComponentState = {
  jobId: null,
  currentFrameIndex: 0
};